<template>
  <van-form
    class="active-form-wrap"
    ref="formEle"
    @submit="sureSignUp"
    @failed="onFailed"
  >
    <van-cell-group inset v-if="originFromProps" class="form-container">
      <template v-for="(formItem, index) of originFromProps">
        <!-- 文本 -->
        <van-field
          :key="index"
          :label="formItem.name"
          v-if="
            !!formItem.show && ['input-text', 'input'].includes(formItem.type)
          "
          :maxlength="50"
          v-model="form[formItem.key]"
          :placeholder="formItem.placeholder"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
          :disabled="formItem.canEdit === 0 ? true : false"
          :name="formItem.key"
        />
        <!-- 数字文本 -->
        <van-field
          :key="index"
          :label="formItem.name"
          v-if="!!formItem.show && formItem.type == 'input-num'"
          v-model.number="form[formItem.key]"
          :placeholder="formItem.placeholder"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
          type="number"
          :disabled="formItem.canEdit === 0 ? true : false"
          :name="formItem.key"
        />
        <!-- 手机号 -->
        <van-field
          :key="index"
          :label="formItem.name"
          v-if="!!formItem.show && formItem.type == 'input-tel'"
          v-model="form[formItem.key]"
          :placeholder="formItem.placeholder"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
          type="tel"
          :maxlength="11"
          :disabled="formItem.canEdit === 0 ? true : false"
          :name="formItem.key"
        />
        <!-- 多行文本 -->
        <van-field
          :key="index"
          :label="formItem.name"
          v-if="!!formItem.show && formItem.type == 'textarea'"
          v-model="form[formItem.key]"
          :placeholder="formItem.placeholder"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
          :maxlength="999"
          :disabled="formItem.canEdit === 0 ? true : false"
          :name="formItem.key"
        >
          <template #input>
            <div class="textarea-box">
              <textarea
                v-model="form[formItem.key]"
                class="textarea"
                :maxlength="100"
                :placeholder="formItem.placeholder"
              ></textarea>
              <div class="tip">{{ form[formItem.key].length }}/999</div>
            </div>
          </template>
        </van-field>
        <!-- 单选框 -->
        <van-field
          :key="index"
          v-if="!!formItem.show && formItem.type == 'radio'"
          :label="formItem.name"
          :disabled="formItem.canEdit === 0 ? true : false"
          :name="formItem.key"
          v-model="form[formItem.key]"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
        >
          <template #input>
            <div
              class="custom-radio-container"
              v-if="formItem.value.length > 2"
            >
              <div
                class="custom-radio-item"
                :class="{
                  'custom-radio__selected':
                    formItem.customSelectedIndex == radioIndex,
                }"
                v-for="(item, radioIndex) in formItem.value"
                :key="radioIndex"
                @click="customRadioChange(formItem, radioIndex)"
              >
                {{ item.name }}
              </div>
              <van-field
                :maxlength="50"
                class="other-input"
                v-if="form[formItem.key] == 'otherChoose'"
                placeholder="请输入其他"
                v-model="form[formItem.key + '_otherChoose']"
              />
            </div>
            <van-radio-group
              v-model="form[formItem.key]"
              direction="horizontal"
              :disabled="formItem.canEdit === 0 ? true : false"
              v-else
            >
              <van-radio
                class="option-bottom"
                v-for="(item, radioIndex) in formItem.value"
                :key="radioIndex"
                :name="item.value"
                checked-color="#0F3CC6"
                :disabled="item.canEdit === 0 ? true : false"
              >
                {{ item.name }}</van-radio
              >
              <van-field
                :maxlength="50"
                class="other-input"
                v-if="form[formItem.key] == 'otherChoose'"
                placeholder="请输入其他"
                v-model="form[formItem.key + '_otherChoose']"
              />
            </van-radio-group>
          </template>
        </van-field>
        <!-- 复选框 -->
        <van-field
          :key="index"
          :label="formItem.name"
          v-if="!!formItem.show && formItem.type == 'checkbox'"
          :disabled="formItem.canEdit === 0 ? true : false"
          :name="formItem.key"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
        >
          <template #input>
            <van-checkbox-group
              v-model="form[formItem.key]"
              direction="horizontal"
              :disabled="formItem.canEdit === 0 ? true : false"
            >
              <van-checkbox
                v-for="(item, checkboxIndex) in formItem.value"
                class="option-bottom"
                :key="checkboxIndex"
                :name="item.value"
                checked-color="#0F3CC6"
                :disabled="item.canEdit === 0 ? true : false"
                shape="square"
                >{{ item.name }}</van-checkbox
              >
              <van-field
                :maxlength="50"
                class="other-input"
                v-if="form[formItem.key].includes('otherChoose')"
                placeholder="请输入其他"
                v-model="form[formItem.key + '_otherChoose']"
              />
            </van-checkbox-group>
          </template>
        </van-field>
        <!-- 选择器 -->
        <van-field
          is-link
          readonly
          :key="index"
          :label="formItem.name"
          v-if="
            !!formItem.show &&
            ['time', 'date', 'datetime'].includes(formItem.type)
          "
          v-model="form[formItem.key]"
          :placeholder="formItem.placeholder"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
          type="text"
          @click="showDatePicker(formItem)"
          :disabled="formItem.canEdit === 0 ? true : false"
          :name="formItem.key"
        />

        <van-field
          is-link
          readonly
          :key="index"
          :label="formItem.name"
          v-if="!!formItem.show && ['selector'].includes(formItem.type)"
          v-model="form[formItem.key]"
          :placeholder="formItem.placeholder"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
          type="text"
          @click="showSelectorPicker(formItem)"
          :disabled="formItem.canEdit === 0 ? true : false"
        />
        <!-- 省市区 -->
        <van-field
          is-link
          readonly
          :key="index"
          v-if="!!formItem.show && formItem.type == 'cascader-address'"
          :label="formItem.name"
          v-model="form[formItem.key + '$_addr']"
          :placeholder="formItem.placeholder"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
          type="text"
          :disabled="formItem.canEdit === 0 ? true : false"
          @click="showAddress(formItem)"
          :name="formItem.key"
        />
        <!-- 单文件上传 -->
        <van-field
          :key="index"
          v-if="!!formItem.show && formItem.type == 'upload-one'"
          :label="formItem.name"
          :disabled="formItem.canEdit === 0 ? true : false"
          :name="formItem.key"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
        >
          <template #input>
            <van-uploader
              v-model="form[formItem.key + '$_upload']"
              :before-read="beforeRead"
              :after-read="afterRead1"
              accept="image/jpeg,image/jpg,image/png"
              :max-count="1"
              :name="formItem.key"
              @oversize="onOversize"
              :max-size="5000 * 1024"
              :click-upload="clickUpload(formItem.key)"
              @delete="delete1"
              :disabled="formItem.canEdit === 0 ? true : false"
            />
          </template>
        </van-field>
        <!-- 多文件上传 -->
        <van-field
          :key="index"
          v-if="!!formItem.show && formItem.type == 'upload-many'"
          :label="formItem.name"
          :disabled="formItem.canEdit === 0 ? true : false"
          :name="formItem.key"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
        >
          <template #input>
            <van-uploader
              multiple
              accept="image/jpeg,image/jpg,image/png"
              v-model="form[formItem.key + '$_upload']"
              :before-read="beforeRead"
              :after-read="afterReadFiles"
              :name="formItem.key"
              :disabled="formItem.canEdit === 0 ? true : false"
              @oversize="onOversize"
              @delete="deleteFile"
              :max-size="5000 * 1024"
              :max-count="formItem.max"
            />
          </template>
        </van-field>
        <!-- 发票 -->
        <van-field
          :key="index"
          :label="formItem.name"
          v-if="!!formItem.show && formItem.type == 'input-company'"
          v-model="form[formItem.key]"
          :placeholder="formItem.placeholder"
          :required="formItem.requrie"
          :rules="rules[formItem.key]"
          :disabled="formItem.canEdit === 0 ? true : false"
          :name="formItem.key"
        >
          <template #input>
            <van-field
              class="input-company"
              :placeholder="formItem.placeholder"
              v-model="form[formItem.key]"
              @update:model-value="handleSearch"
            />
            <div class="search-result">
              <van-loading
                type="spinner"
                size="16"
                color="#0f3cc6"
                v-show="searchLoading"
                >查询中...</van-loading
              >
              <div class="result-list">
                <div
                  v-show="showInvoiceList"
                  class="result-item"
                  v-for="(res, index) in invoiceList"
                  :key="index"
                  @click="handleChooseCompany(formItem.key, res)"
                >
                  {{ res.name }}
                </div>
              </div>
            </div>
          </template>
        </van-field>
      </template>
    </van-cell-group>
    <div class="form-btn-box" v-if="showSubmitBtn">
      <van-button
        class="btn"
        round
        block
        :loading="subBtnLoading"
        type="primary"
        native-type="submit"
      >
        {{ subBtnTetx ? subBtnTetx : "提交" }}
      </van-button>
    </div>
  </van-form>
  <!-- 时间选择器的弹窗 -->
  <van-popup v-model:show="dateObj.visible" position="bottom">
    <van-datetime-picker
      :type="dateObj.type"
      @confirm="onConfirm"
      @cancel="dateObj.visible = false"
    />
  </van-popup>
  <!-- 地址选择器的弹窗 -->
  <van-popup
    @click-overlay="closeAddressCascader"
    v-model:show="showAddrCascader"
    round
    position="bottom"
  >
    <van-cascader
      v-model="form[currentSelectKey + '$_addr']"
      title="请选择省 / 市 / 区"
      :options="cityList"
      @close="closeAddressCascader"
      active-color="#0F3CC6"
      @finish="onAddrChooseFinish"
    />
  </van-popup>
  <!-- 下拉选项的弹窗 -->
  <van-popup v-model:show="selectorShow" position="bottom">
    <van-picker
      :columns-field-names="{ text: 'name' }"
      :columns="selectorList[currentSelectKey]"
      @confirm="onSelectorConfirm"
      @cancel="selectorShow = false"
    />
  </van-popup>
</template>

<script>
import { defineComponent, ref, reactive } from "vue";
import cityList from "@/utils/city.json";
import { dateFormat } from "@/utils/dateFormat";
import oss from "@/utils/aliOss";
import { Toast } from "vant";
import { debounce } from "@/utils/help.js";
import { getTaitouInfo } from "@/api/other";
export default defineComponent({
  props: {
    formPropsData: Object,
    showSubmitBtn: { type: Boolean, default: true },
    subBtnTetx: String,
  },
  emits: ["updatedata"],
  setup(props, { emit }) {
    const form = ref({});
    const rules = ref(props.formPropsData.rules);
    // console.log(rules.value);
    const originFromProps = ref(props.formPropsData.form);
    // 历史表单职业固定数据
    const trainerList = [
      { code: 1, name: "医师" },
      { code: 2, name: "护师" },
      { code: 3, name: "技师" },
      { code: 6, name: "药师" },
      { code: 5, name: "在读学生" },
      { code: 4, name: "其他" },
    ];
    // 向外暴露初始格式化值
    const firstFormData = ref({});
    const formmatPropsData = () => {
      originFromProps.value.forEach((item) => {
        if (item.type === "cascader-address") {
          // 省市区特殊处理
          // record = ele.defaultValue.substring(0, ele.defaultValue.indexOf("|"));
          form.value[item.key] = item.defaultValue || "";
          // 回显的话取最后一个字段
          form.value[item.key + "$_addr"] = item.defaultValue
            ? item.defaultValue
                .slice(0, item.defaultValue.indexOf("|"))
                .replaceAll(",", "/")
            : "";
        } //  职业特殊处理
        else if (item.defaultValue && item.key === "trainer") {
          item.defaultValue = Number(item.defaultValue);
          const profession = trainerList.find(
            (trainer) => trainer.code == item.defaultValue
          );
          form.value[item.key] = profession.name;
        } else if (["upload-many", "upload-one"].includes(item.type)) {
          form.value[item.key + "$_upload"] = form.value[item.key] || [];
          form.value[item.key] = form.value[item.key] || [];
        } else if (["radio", "checkbox"].includes(item.type)) {
          // 单选多选需要判断是否选了其他 'otherChoose'
          // 处理单选其他选项的值
          if (item.defaultValue) {
            if (item.type == "radio") {
              if (item.defaultValue.startsWith("otherChoose")) {
                form.value[item.key] = "otherChoose";
                form.value[item.key + "_otherChoose"] =
                  item.defaultValue.split("|")[1];
              } else {
                form.value[item.key] = item.defaultValue;
                form.value[item.key + "_otherChoose"] = "";
              }
            } else {
              //管理后台传递的肯定是数组
              if (Array.isArray(item.defaultValue)) {
                form.value[item.key] = item.defaultValue;
                form.value[item.key + "_otherChoose"] = "";
              } else {
                // 后端绑定回显的数据肯定是字符串
                item.defaultValue.split("#").map((item) => {
                  if (item.startsWith("otherChoose")) {
                    item = item.defaultValue.split("|")[1];
                    form.value[item.key + "_otherChoose"] = item;
                  } else {
                    item = item.defaultValue;
                    form.value[item.key + "_otherChoose"] = "";
                  }
                  return item;
                });
              }
            }
          } else {
            form.value[item.key + "_otherChoose"] = "";
          }
        } else {
          form.value[item.key] = item.defaultValue;
        }
        // 单选长度超过3个的加上一个selected字段，标识选择哪个
        if (item.type === "radio" && item.value.length > 2) {
          item.customSelectedIndex = -1;
        }
      });
      firstFormData.value = JSON.parse(JSON.stringify(originFromProps.value));
    };

    formmatPropsData();

    //时间选择器
    const dateObj = reactive({ type: "", visible: false });
    // 时间选择器
    const showDatePicker = (data) => {
      if (data.canEdit === 0) {
        return false;
      }
      currentSelectKey.value = data.key;
      dateObj.visible = true;
      dateObj.type = data.type;
    };
    // 时间确认
    const onConfirm = (object) => {
      switch (dateObj.type) {
        case "date":
          form.value[currentSelectKey.value] = dateFormat(
            new Date(object),
            "yyyy-MM-dd"
          );
          dateObj.visible = false;
          break;
        case "time":
          form.value[currentSelectKey.value] = object;
          dateObj.visible = false;
          // Toast.fail("选择日期不能超过当前日期");
          break;
        case "datetime":
          form.value[currentSelectKey.value] = dateFormat(
            new Date(object),
            "yyyy-MM-dd hh:mm"
          );
          dateObj.visible = false;
          break;
      }
    };
    // 下拉选择
    const selectorShow = ref(false);
    const selectorList = reactive({});
    const currentSelectKey = ref(""); //记录所有的点击需要弹窗的key
    // 下拉选择器
    const showSelectorPicker = (data) => {
      if (data.canEdit === 0) {
        return false;
      }
      selectorList[data.key] = data.value;
      currentSelectKey.value = data.key;
      selectorShow.value = true;
    };
    const onSelectorConfirm = (option) => {
      form.value[currentSelectKey.value] = option.name;
      currentSelectKey.value = "";
      selectorShow.value = false;
    };

    // 地区选择
    const showAddrCascader = ref(false);
    const onAddrChooseFinish = ({ selectedOptions }) => {
      const [pro, city, area] = selectedOptions;
      //   传给后台的数据
      form.value[
        currentSelectKey.value
      ] = `${pro.text},${city.text},${area.text}|${pro.value},${city.value},${area.value}`;
      //  回显的数据
      form.value[
        currentSelectKey.value + "$_addr"
      ] = `${pro.text}/${city.text}/${area.text}`;
      showAddrCascader.value = false;
    };
    // 省市区
    const showAddress = (data) => {
      if (data.canEdit === 0) {
        return false;
      }
      currentSelectKey.value = data.key;
      showAddrCascader.value = true;
    };
    const closeAddressCascader = () => {
      form.value[currentSelectKey.value + "$_addr"] = "";
      showAddrCascader.value = false;
    };
    const otherDefaultVal = "其他";
    // 设置其他选项的值方法
    const setOtherChoose = (newForm) => {
      const radioAndCheckbox = originFromProps.value.filter((item) =>
        ["radio", "checkbox"].includes(item.type)
      );
      Object.keys(newForm).forEach((key) => {
        const findObj = radioAndCheckbox.find((item) => item.key === key);
        if (findObj) {
          if (
            findObj.type == "radio" &&
            newForm[findObj.key] == "otherChoose"
          ) {
            newForm[findObj.key] =
              newForm[findObj.key] +
              "|" +
              (newForm[findObj.key + "_otherChoose"] || otherDefaultVal);
          }
          if (
            findObj.type == "checkbox" &&
            newForm[findObj.key].includes("otherChoose")
          ) {
            newForm[findObj.key] = newForm[findObj.key]
              .map((checkVal) => {
                if (checkVal == "otherChoose") {
                  checkVal =
                    checkVal +
                    "|" +
                    (newForm[findObj.key + "_otherChoose"] || otherDefaultVal);
                }
                return checkVal;
              })
              .join("#");
          }
        }
      });
      return newForm;
    };
    // 提交
    const sureSignUp = async () => {
      const subData = JSON.parse(JSON.stringify(form.value));
      for (let item of originFromProps.value) {
        if (
          rules.value[item.key] &&
          rules.value[item.key][0].required &&
          ["upload-one", "upload-many"].includes(item.type) &&
          form.value[item.key].length == 0
        ) {
          Toast.fail(item.requiredMsg);
          return false;
        }
        if (["upload-one", "upload-many"].includes(item.type)) {
          const hasLoading = form.value[item.key + "$_upload"].find(
            (picInfo) => picInfo.status == "uploading"
          );
          const hasError = form.value[item.key + "$_upload"].find(
            (picInfo) => picInfo.status == "error"
          );
          if (hasLoading || hasError) {
            Toast.fail("图片上传中，请稍后!");
            return false;
          }
        }
        if (item.key == "trainer") {
          const profession = trainerList.find(
            (trainer) => trainer.name == subData[item.key]
          );
          subData[item.key] = profession ? profession.code : "";
        }
      }
      subBtnLoading.value = true; //加载中
      // 文件上传时，删除多余的数据后传递
      deleteRedundantField(subData);
      // for (const key in subData) {
      //   if (key.endsWith("$_upload") || key.endsWith("$_addr")) {
      //     Reflect.deleteProperty(subData, key);
      //   }
      // }
      // const newForm = JSON.parse(JSON.stringify(form.value));
      const sendFrom = setOtherChoose(subData);
      // console.log("提交的数据", sendFrom);
      emit("updatedata", sendFrom);
      subBtnLoading.value = false; //加载中
    };
    //  去除多余的字段(上传$_upload、工作地点$_addr)
    function deleteRedundantField(data) {
      for (const key in data) {
        if (key.endsWith("$_upload") || key.endsWith("$_addr")) {
          Reflect.deleteProperty(data, key);
        }
      }
    }

    function getFormData() {
      const formatData = JSON.parse(JSON.stringify(form.value));
      for (let item of originFromProps.value) {
        let isEmpty = !form.value[item.key] || form.value[item.key].length == 0;
        if (
          rules.value[item.key] &&
          rules.value[item.key][0].required &&
          isEmpty
        ) {
          Toast.fail(item.placeholder);
          return false;
        }
        if (item.key == "trainer") {
          const profession = trainerList.find(
            (trainer) => trainer.name == formatData[item.key]
          );
          formatData[item.key] = profession.code;
        }
      }
      // 删除多余的字段
      deleteRedundantField(formatData);
      // 处理其他选项
      const res = setOtherChoose(formatData);
      return res;
    }

    let formEle = ref("");
    const onFailed = (failed) => {
      const errors = failed.errors;
      formEle.value.scrollToField(errors[0].name, true);
    };

    let clickImgKey = ref("");
    const clickUpload = (key) => {
      clickImgKey.value = key;
    };
    const afterRead1 = async (file, { name }) => {
      file.status = "uploading";
      file.message = "上传中...";
      let data = await oss.ossUploadImg(file);
      if (!data) {
        file.status = "failed";
        file.message = "上传失败";
      }
      if (data) {
        file.status = "done";
        file.message = "";
        const url = `https://ntppc.oss-cn-shanghai.aliyuncs.com/${data.fileUrl}`;
        form.value[name].push({ url: url, name: data.fileName });
      }
    };
    const delete1 = (file, { name }) => {
      form.value[name] = [];
    };
    // 文件上传前校验类型
    const beforeRead = (options) => {
      if (Array.isArray(options)) {
        const hasUnExcept = options.find(
          (option) =>
            !["image/jpeg", "image/jpg", "image/png"].includes(option.type)
        );
        if (hasUnExcept) {
          Toast("仅支持 jpeg、jpg、png 格式图片");
          return false;
        }
      } else if (
        !["image/jpeg", "image/jpg", "image/png"].includes(options.type)
      ) {
        Toast("仅支持 jpeg、jpg、png 格式图片");
        return false;
      }
      return true;
    };

    // 多文件上传
    const afterReadFiles = async (options, { name }) => {
      // 只传了一张图片的时候是对象形式，多张是数组
      if (Array.isArray(options)) {
        for (const file of options) {
          file.status = "uploading";
          file.message = "上传中...";
        }
        for (const option of options) {
          const res = await oss.ossUploadImg(option);
          if (!res) {
            options.forEach((item) => {
              if (item.file.name == option.file.name) {
                item.status = "failed";
                item.message = "上传失败";
              }
            });
          } else {
            option.status = "done";
            option.message = "";
            form.value[name].push({
              url: `https://ntppc.oss-cn-shanghai.aliyuncs.com/${res.fileUrl}`,
              name: res.fileName,
              objectUrl: option.objectUrl,
            });
          }
        }
      } else {
        options.status = "uploading";
        options.message = "上传中...";
        let res = await oss.ossUploadImg(options);
        if (res) {
          options.status = "done";
          options.message = "";
          form.value[name].push({
            url: `https://ntppc.oss-cn-shanghai.aliyuncs.com/${res.fileUrl}`,
            name: res.fileName,
            objectUrl: options.objectUrl,
          });
        }
      }
    };
    // 文件大小超出
    const onOversize = () => {
      // console.log(file);
      Toast("文件大小不能超过 5M !");
    };
    const deleteFile = (file, { name }) => {
      form.value[name] = form.value[name].filter(
        (item) => item.objectUrl !== file.objectUrl
      );
    };
    // 长度超过三个的自定义单选
    const customRadioChange = (formItem, selectedIndex) => {
      formItem.customSelectedIndex = selectedIndex;
      form.value[formItem.key] = formItem.value[selectedIndex].value;
      if (form.value[formItem.key] !== "otherChoose") {
        form.value[formItem.key + "_otherChoose"] = "";
      }
    };
    const subBtnLoading = ref(false);
    // 发票信息
    const invoiceList = ref([]);
    const searchLoading = ref(false);
    const showInvoiceList = ref(false);
    const handleSearch = debounce(async (value) => {
      if (!value) {
        invoiceList.value = [];
        searchLoading.value = false;
        showInvoiceList.value = false;
        return;
      }
      invoiceList.value = [];
      searchLoading.value = true;
      const res = await getTaitouInfo(value).catch(() => {
        searchLoading.value = false;
        invoiceList.value = [];
      });
      invoiceList.value = res.results;
      searchLoading.value = false; //停止加载
      showInvoiceList.value = true; //展示下拉框
      // console.log("查询信息", res);
    }, 800);
    // 确认选择
    const handleChooseCompany = (key, option) => {
      form.value[key] = option.name;
      form.value.invoice_shuihao = option.shuihao; //税号
      form.value.invoice_bankno = option.bankno; //开户银行号
      form.value.invoice_bankname = option.bankname; //开户行
      form.value.invoice_address = option.address; //地址
      form.value.invoice_phone = option.phone; // 开户联系方式
      invoiceList.value = [];
      showInvoiceList.value = false;
    };
    return {
      form,
      rules,
      originFromProps,
      showDatePicker,
      showAddress,
      sureSignUp,
      onFailed,
      formEle,
      afterRead1,
      clickUpload,
      delete1,
      getFormData,
      afterReadFiles,
      onOversize,
      deleteFile,
      beforeRead,
      subBtnLoading,
      customRadioChange,
      dateObj,
      selectorShow,
      showAddrCascader,
      cityList,
      onAddrChooseFinish,
      onConfirm,
      showSelectorPicker,
      selectorList,
      currentSelectKey,
      onSelectorConfirm,
      closeAddressCascader,
      invoiceList,
      searchLoading,
      handleSearch,
      showInvoiceList,
      handleChooseCompany,
    };
  },
});
</script>

<style lang="less" scoped>
.active-form-wrap {
  .van-cell-group {
    height: 330px;
    overflow-y: scroll;
  }
  .van-cell {
    display: block;
    padding: 0;
    margin-bottom: 12px;
    &.input-company {
      margin-bottom: 0;
    }
    &::after {
      display: none;
    }
    :deep(.van-field__label) {
      width: 100%;
      margin-right: 0;
      line-height: 20px;
      padding: 12px 0;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #323233;
    }
    :deep(.van-field__body) {
      input[class="van-field__control"] {
        height: 36px;
        box-sizing: border-box;
        background: #f7f8fa;
        border-radius: 8px;
        padding: 8px;
      }
      // textarea {
      //   height: 84px !important;
      //   background: #f7f8fa;
      //   border-radius: 8px;
      //   padding: 8px;
      // }
    }
    :deep(.van-field__control) {
      &::placeholder {
        color: #d5d8df;
      }
      &:disabled {
        color: #b1b1b3;
        -webkit-text-fill-color: #b1b1b3;
      }
      &.van-field__control--custom {
        flex-wrap: wrap;
      }
    }
    :deep(.van-checkbox) {
      .van-checkbox__icon .van-icon {
        border-radius: 4px;
      }
    }
    // :deep(.van-field__value) {
    //   height: 36px;
    //   box-sizing: border-box;
    //   background: #f7f8fa;
    //   border-radius: 8px;
    //   padding: 8px;
    // }
  }
  :deep(.van-cell--clickable) {
    .van-field__body {
      position: relative;
      &::after {
        position: absolute;
        top: 9px;
        right: 8px;
        content: "";
        width: 18px;
        height: 19px;
        background: url("@/assets/H5/play/arrow-select.png") no-repeat;
        background-size: contain;
      }
      .van-field__control::placeholder {
        color: #999;
      }
    }
    .van-cell__right-icon {
      display: none;
      &::after {
        display: none;
      }
    }
  }
  .form-container {
    margin-bottom: 60px;
  }
  .form-btn-box {
    position: fixed;
    display: block;
    width: 100%;
    box-sizing: border-box;
    bottom: 0;
    padding: 5px 16px 20px;
    .van-button--primary {
      background-color: #0f3cc6;
      border: none;
    }
  }

  /deep/ .selector-pop {
    .van-drawer-content {
      bottom: calc(100rpx + env(safe-area-inset-bottom));
    }
  }
  input::-webkit-input-placeholder {
    color: red;
    font-size: 20px;
  }
  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: red;
    font-size: 20px;
  }
  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: red;
    font-size: 20px;
  }
  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: red;
    font-size: 20px;
  }

  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  /deep/ uni-scroll-view {
    .uni-scroll-view {
      padding-left: 16rpx;
      box-sizing: border-box;
      &::-webkit-scrollbar {
        display: block;
        width: 16rpx !important;
        height: 16rpx !important;
        background-color: #f5f5f5;
      }

      /*定义滚动条轨道 内阴影+圆角*/
      &::-webkit-scrollbar-track {
        border-radius: 10rpx;
        background-color: #fff;
      }

      /*定义滑块 内阴影+圆角*/
      &::-webkit-scrollbar-thumb {
        border-radius: 10rpx;
        -webkit-box-shadow: inset 0 0 6rpx rgba(0, 0, 0, 0.3);
        background-color: #999;
      }
    }
  }
}
.option-bottom {
  margin-bottom: 12px;
  margin-right: 16px;
}
.other-input {
  padding: 0 8px;
  // border-bottom: 1px solid #0f3cc6;
  margin-top: 12px;
}
.custom-radio-container {
  display: flex;
  flex-wrap: wrap;
  .custom-radio-item {
    line-height: 20px;
    padding: 4px 14px;
    background: #ffffff;
    font-size: 14px;
    color: #666;
    border-radius: 4px;
    border: 1px solid #e1e2e6;
    margin-right: 16px;
    margin-bottom: 12px;
    &.custom-radio__selected {
      border-color: #0f3cc6;
      color: #0f3cc6;
    }
  }
}
.textarea-box {
  width: 100%;
  height: 84px;
  padding: 8px;
  box-sizing: border-box;
  background-color: #f7f8fa;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  .textarea {
    flex: 1;
    width: 100%;
    border: none;
    background-color: #f7f8fa;
    resize: none;
    font-size: 14px;
    &::-webkit-input-placeholder {
      color: #999999;
      font-size: 14px;
    }
  }

  .tip {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    text-align: right;
    line-height: 16px;
  }
}
.search-result {
  width: 100%;
  border-radius: 8px;
  margin-top: 2px;
  background-color: #fafbfb;
  .result-list {
    max-height: 150px;
    padding: 0 8px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    .result-item {
      padding: 4px 0;
      border-top: 1px solid #efefef;
      &:first-child {
        border-top: none;
      }
    }
  }
}
</style>
